// @mui
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
// hooks
import useResponsive from "../../../hooks/useResponsive";
// components
import DIOText from "../../../components/DIOText";
import SvgIconStyle from "../../../components/SvgIconStyle";

// ------------------------------------------------------------------------------

export default function DIOManagerCallDialog({ open, closeDialog }) {
  const smUp = useResponsive('up', 'sm');

  return (
    <Dialog open={open} fullWidth maxWidth="xs">
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <SvgIconStyle src={`/icons/icon-headphone-mono.svg`} sx={{ color: 'info.main' }} />
        <Typography variant={smUp ? "h5" : "subtitle1"} sx={{ wordBreak: "keep-all" }} paragraph>
          <DIOText /> 매니저와 전화 통화 이후 매칭이 진행됩니다.
        </Typography>
        <Typography variant={smUp ? "body1": "body2"} sx={{ wordBreak: "keep-all" }}>
          작성하신 내용을 확인한 후, 매칭에 필요한 추가 정보를 여쭙기 위해 전화드릴 예정입니다. {!smUp && <br />}(영업일 1일 이내)
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: { xs: 3, sm: 4 } }}>
        <Button
          variant="contained"
          onClick={closeDialog}
          fullWidth={!smUp}
          size="large"
          sx={{ px: 5 }}
        >
          확인했어요
        </Button>
      </DialogActions>
    </Dialog>
  )
}
